/**
 * /en/admin/structure/block-content/manage/mercury_health_information/fields
 */
import Field from "../core/field.es6.js";
import LinkField from "../core/link-field.es6.js";

export default class MercuryHealthInformationBlockField extends Field {
  get submissionUrl() {
    return new LinkField({
      machineName: 'field_submission_url',
      parentElement: this,
    });
  }
}
